// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  'With this widget you "fact-check" statements and quotes and add an explanation.';
const CONFIG: InteractivesMenuItemConfig = {
  name: "Fact checker embed",
  id: "fact-check",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable", "Explainer"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/fact-check/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "FactCheckConfigTool" */ "app/components/tools/FactCheckConfigTool/FactCheckConfigTool"),
    loading: DynamicImportLoader,
    modules: ["FactCheckConfigTool"]
  })
};

export default CONFIG;
